/**
 * Return details elements from desktop menu
 * @returns {Object} details elements
 */
function getMenuDetails() {
  return document.querySelectorAll('nav.megamenu > ul > li > details.megamenu__submenu');
}

function init() {
  for (const elem of getMenuDetails()) {
    elem.addEventListener('toggle', (e) => {
      toggleOpenOneOnly(e);
    });
  }
  const megamenuMobile = document.querySelectorAll('.megamenu-mobile')[0];
  const megamenuMobileButtons = document.querySelectorAll('.megamenu__mobile-menu-btn');
  const megamenuMobileCloseButtons = document.querySelectorAll('.megamenu__mobile-menu-btn-close');
  for (const btn of megamenuMobileButtons) {
    btn.addEventListener('click', () => {
      megamenuMobile.showModal();
      for (const button of megamenuMobileButtons) {
        button.setAttribute('aria-expanded', true);
      }

      for (const button of megamenuMobileCloseButtons) {
        button.setAttribute('aria-expanded', true);
      }
    });
  }
  for (const btn of megamenuMobileCloseButtons) {
    btn.addEventListener('click', () => {
      megamenuMobile.close();
      for (const button of megamenuMobileButtons) {
        button.setAttribute('aria-expanded', false);
      }

      for (const button of megamenuMobileCloseButtons) {
        button.setAttribute('aria-expanded', false);
      }
    });
  }
}

/**
 * Closes all but current details container when a details element is toggled. If element from mobile menu was opened and menu, scrolls it into view
 * @param {Event} e - event
 * @param {String} selector - details element selector
 */
function toggleOpenOneOnly(e, selector) {
  if ( e.target.open ) {
    for (const elem of getMenuDetails()) {
      if (elem !== e.target && elem.open) {
        elem.open = false;
      }
    }
    // scroll into view if mobile submenu was opened
    if(document.getElementsByClassName('megamenu-mobile')[0].contains(e.target)) {
      e.target.getElementsByTagName('summary')[0].scrollIntoView({behavior: 'smooth', block: 'start'});
    }
    addInputCloseListeners();
  } else {
    removeInputCloseListeners();
  }
}

/**
 * Closes all submenus if clicked outside the menu, and remove input close listeners (JRINTCONT-812).
 * @param {Event} e - event
 */
function closeIfClickedOutside(e) {
  if(![...getMenuDetails()].some(f => f.contains(e.target))) {
    for (const elem of getMenuDetails()) {
      elem.open = false;
    }
    removeInputCloseListeners();
  }
}

/**
 * Closes all submenus if esc is pressed, and remove input close listeners (JRINTCONT-812).
 * @param {Event} e - event
 */
function closeOnEscape(e) {
  if (e.code === 'Escape') {
    for (const elem of getMenuDetails()) {
      elem.open = false;
    }
    removeInputCloseListeners();
  }
}

/**
 * Add input close listeners for menu (JRINTCONT-812): esc pressing and clicking outside the menu.
 */
function addInputCloseListeners() {
  document.addEventListener('click', closeIfClickedOutside);
  document.addEventListener('keydown', closeOnEscape);
}

/**
 * Remove input close listeners (JRINTCONT-812).
 */
function removeInputCloseListeners() {
  document.removeEventListener('click', closeIfClickedOutside); 
  document.removeEventListener('keydown', closeOnEscape);
}

export default { init };
export { init };
